import { api } from "..";

export async function resetMarketMatch({
  matchId,
}: {
  matchId: string;
}) {
  const res = await api.client.delete(`/matches/markets/${matchId}`);
  return res.data;
}
